import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/service/shared/alert/alert.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { SmtpConfigurationService } from 'src/app/service/smtp-configuration/smtp-configuration.service';

import { PermissionsService } from 'src/app/service/auth/permissions.service';

declare const reloadMenu: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('closebutton') closebutton;

  innerHeight;
  email;
  password;
  remember;
  errors;
  forgotPasswordErrors;
  forgotPasswordSuccess;
  egan_hub_site_logo;

  forgotPasswordForm: FormGroup;
  loginForm: FormGroup;

  constructor(
    private router: Router,
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private localStorageService: LocalstorageService,
    private storage: AngularFireStorage,
    private smtpConfiguration: SmtpConfigurationService,
    private permissionsService: PermissionsService,
  ) { }

  ngOnInit(): void {
    console.log("James - hello from AWS :)")
    this.getDesignDetails();
    this.innerHeight = window.innerHeight + 'px';
    let remember = this.localStorageService.getItem('remember');
    if (remember) {
      let data = {
        email: this.localStorageService.getItem('email'),
        password: this.localStorageService.getItem('password'),
        remember: 1,
      };

      this.createForm(data);
    } else {
      this.createForm();
    }

    this.createForgotPasswordForm();
  }

  createForm(data = null) {
    if (data) {
      this.loginForm = this.formBuilder.group({
        email: [data['email'], [Validators.email, Validators.required]],
        password: [data['password'], Validators.required],
        remember: [data['remember']],
      });
    } else {
      this.loginForm = this.formBuilder.group({
        email: ['', [Validators.email, Validators.required]],
        password: ['', Validators.required],
        remember: [],
      });
    }
  }

  createForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  onSubmit(form) {
    if (form.invalid) {
    } else {
      if (
        this.loginForm.get('remember').value == '' ||
        this.loginForm.get('remember').value == undefined ||
        this.loginForm.get('remember').value == false
      ) {
        this.localStorageService.removeItem('remember');
        this.localStorageService.removeItem('email');
        this.localStorageService.removeItem('password');
      }
      this.auth.login(form.value.email, form.value.password).subscribe(
        res => this.onSuccess(res),
        err => this.alertService.showAlert(err.error.errors[0].message, 'error'),
      );
    }
  }

  onSuccess(result) {
    if (result.data) {
      if (this.loginForm.get('remember').value) {
        this.localStorageService.setItem('email', this.loginForm.get('email').value);
        this.localStorageService.setItem('password', this.loginForm.get('password').value);
        this.localStorageService.setItem('remember', 'true');
      }
      this.localStorageService.setItem('token', result.data.token);
      this.localStorageService.setItem('userId', result.data.id);
      this.localStorageService.setItem('user', JSON.stringify(result.data));
      this.permissionsService.refresh();
      this.router.navigateByUrl('/jobs');
      reloadMenu();
    } else {
      this.alertService.showAlert(result.errors.message, 'error');
    }
  }

  onForgotPasswordSubmit(form) {
    if (form.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
    } else {
      this.auth
        .forgotPassword(form.value.email, this.egan_hub_site_logo)
        .subscribe(res => this.onForgotPasswordSuccess(res));
    }
  }

  resetForgotPasswordForm() {
    this.forgotPasswordForm.reset();
  }

  onForgotPasswordSuccess(result) {
    if (result.data) {
      this.closebutton.nativeElement.click();
      this.alertService.showAlert('Check your email for the link to reset your password.', 'success_with_sign');
    } else {
      this.alertService.showAlert(result.errors.message, 'error_with_sign', '#forgotpwd-error-display');
    }
  }

  getDesignDetails() {
    this.smtpConfiguration.getSiteConfiguration().subscribe(
      res => this.onConfigurationSuccess(res),
      error => this.onConfigurationError(),
    );
  }

  onConfigurationSuccess(result) {
    if (typeof result.data) {
      if (result.data) {
        let newArray = {};
        result.data.forEach(element => {
          newArray[element.config_item] = element.config_value;
        });
        if (newArray['egan_hub_site_logo'] != '') {
          try {
            let siteLogo = this.storage.ref('uploads/site_logo/' + newArray['egan_hub_site_logo']);
            if (siteLogo) {
              siteLogo.getDownloadURL().subscribe(url => {
                if (url) {
                  this.egan_hub_site_logo = url;
                }
              });
            }
          } catch (error) { }
        }
      }
    }
  }

  onConfigurationError() { }
}
